import { Suspense } from "react";
import { Outlet } from "react-router";

import useAuth from "~/hooks/auth/useAuth";
import useClientRedirect from "~/hooks/useClientRedirect";

import RocketRentLogo from "./RocketRentLogo";

const LayoutAuth = () => {
  const clientRedirect = useClientRedirect();
  const { isInitialLoad, isLoading, isAuthenticated, user } = useAuth();

  if (isInitialLoad && isLoading) {
    return null;
  }

  if (!isLoading && isAuthenticated && user?.internalRole) {
    if (user.internalRole === "landlord") {
      clientRedirect("/landlord");
    }

    if (user.internalRole === "tenant") {
      clientRedirect("/tenant/leases");
    }

    return null;
  }

  return (
    <div className="flex min-h-full flex-1">
      <div className="flex min-h-full flex-1 flex-col justify-center px-4 py-12 sm:px-6 lg:px-8 lg:py-20">
        <Suspense>
          <RocketRentLogo />
        </Suspense>

        <div className="mt-2 sm:mx-auto sm:w-full sm:max-w-[448px]">
          <div className="bg-white px-6 py-8 sm:px-8">
            <Suspense>
              <Outlet />
            </Suspense>
          </div>
        </div>
      </div>
      <div className="relative hidden w-0 flex-1 lg:block">
        <img
          className="absolute inset-0 h-full w-full object-cover"
          src="/app/assets/images/login/sunny-apartments.png"
          alt=""
        />
      </div>
    </div>
  );
};

export default LayoutAuth;
